// extracted by mini-css-extract-plugin
export var aircallIframe = "_f0-3";
export var fabContainer = "_f0-5";
export var fabRinging = "_f0-6";
export var loadingOverlay = "_f0-4";
export var pulse = "_f0-7";
export var widgetContent = "_f0-2";
export var widgetPanel = "_f0-0";
export var widgetPanelExpanded = "_f0-1";